var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"_QL2CjAnfrEDgDEv9R1aH"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["promisetracker@code-for-africa"]={id:"_QL2CjAnfrEDgDEv9R1aH"};
      